module.exports = __webpack_public_path__ + "img/ClaudiaGonzalez-G.f1288789.png";